import * as React from "react";
import ToolTip from "components/ToolTip/index";
import Chip from "../Chips/Chip";
import {white} from "colors";
import {tagClass} from "uiTestClasses";

interface TagProps {
    description: string;
    tagName: string;
    tagColor: string;
    small?: boolean;
    showTooltip?: boolean;
    tabIndex?: number;
    onClick?: () => void;
    onRequestDelete?: (event: object) => void;
}

const Tag: React.StatelessComponent<TagProps> = props => {
    const {tagName, tagColor, tabIndex, description, small = false} = props;
    const tagDescription = (description ? tagName + ": " + description : "Tag: " + tagName);

    if (!small) {
        return <Chip className={tagClass}
                     tabIndex={tabIndex}
                     onClick={props.onClick}
                     onRequestDelete={props.onRequestDelete}
                     backgroundColor={tagColor}
                     description={tagDescription}
                     labelColor={white}>{tagName}</Chip>;
    }
    return (<ToolTip content={tagName}>
        <em className={`${"fa fa-square tag-swatch"} ${tagClass}`} style={{color : tagColor, marginLeft: "0.0625rem", marginRight: "0.0625rem"}}/>
    </ToolTip>);
};

export default Tag;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Tag/Tag.tsx